import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'td'> & {
  padding?: number | null | undefined
}

/**
 * 基本的なTdコンポーネント
 */
export const BasicTd: FC<Props> = ({
  children,
  className,
  padding,
  ...props
}) => {
  return (
    <td
      {...props}
      className={clsx([
        'text-left',
        padding === 0 || padding ? `p-${padding}` : 'p-4',
        className
      ])}
    >
      {children}
    </td>
  )
}
